/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const { Tab, Tabs, TabContent } = require('@andes/tabs');
const Breadcrumb = require('@andes/breadcrumb');
const Snackbar = require('@andes/snackbar');
const ProgressIndicatorCircular = require('@andes/progress-indicator-circular');
const Message = require('@andes/message');
const View = require('./view');
const Properties = require('./properties');
const Language = require('./language');
const Resolution = require('./resolution');
const { useLiveDemoContext, LiveDemoContextProvider } = require('./Provider/liveDemoContext');
const SnippetFront = require('./snippetFront');
const SnippetBack = require('./snippetBack');
const isMobile = require('../../../../node_modules/ismobilejs');
const { configureEventTracker } = require('../../../event-tracker');
const { getEventTracker } = require('../../../event-tracker');
const { FeedbackCSAT } = require('./components/FeedbackCSAT');

const { useEffect } = React;
const Tracker = getEventTracker();
const { BreadcrumbLevel } = Breadcrumb;

const LiveDemoSnackbar = ({ i18n }) => {
  const { behaviorData, setBehaviorData } = useLiveDemoContext();

  return (
    <Snackbar
      message={behaviorData?.snackbarData?.message}
      color={behaviorData?.snackbarData?.type}
      show={behaviorData?.snackbarData?.show}
      delay={behaviorData?.snackbarData?.delay}
      onChange={(newStatus) => {
        setBehaviorData(prev => ({
          ...prev,
          snackbarData: {
            show: newStatus,
            message: i18n.gettext('Código copiado con éxito.'),
            type: 'green',
            delay: 3000,
          },
        }));
      }}
    />
  );
};


const SnippetSpinner = () => {
  const { behaviorData } = useLiveDemoContext();
  const spinnerHome = document.querySelector('.live-demo-home__spinner');

  useEffect(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', null);
    } else if (spinnerHome.length > 0) {
      spinnerHome.style.display = 'none';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.readyState]);

  return (
    <>
      {behaviorData?.showLayoutSpinner && (
        <div className="live-demo-tab-item-demo__spinner">
          <ProgressIndicatorCircular modifier="inline" size="medium" />
        </div>
      )}
    </>
  );
};

const CustomHook = ({ customHook }) => {
  const { formData, setFormData } = useLiveDemoContext();
  customHook({ ...formData, setFormData });

  return <></>;
};

const Demo = (props) => {
  const { componentProps, componentDemo, componentSnippetFront, componentSnippetBack, deviceType, i18n, lang, userData, platform, liveDemoId, customHook, isLoggedAccountATestUser, customMessage, email, actualUrl } = props;
  useEffect(() => {
    configureEventTracker({
      lang,
      isMobile: isMobile.any,
      siteId: platform.siteId,
      isLogged: (userData && userData.id !== null && userData.id !== undefined),
    });
  }, []);

  const initialValues = {
    resolution: 'desktop',
    // eslint-disable-next-line no-nested-ternary
    language: lang,
  };

  componentProps?.options?.forEach(({ defaultValue, items, id }) => {
    if (items?.length > 0) {
      const siteId = items.find(item => item.siteId === platform.siteId);
      if (siteId) {
        initialValues.publicKey = siteId.value;
      }
    }
    if (defaultValue) {
      initialValues[id] = defaultValue;
    }
  });

  componentProps?.advancedOptions?.forEach(({ defaultValue, id }) => {
    if (defaultValue) {
      initialValues[id] = defaultValue;
    }
  });

  const tabContent = [
    {
      visible: true,
      content: (
        <Tab
          title="Layout"
          className="live-demo-tab-item"
          onClick={() => {
            Tracker.send(`mpdevelopers/live_demo/click_${liveDemoId}_tab`, 'layout');
          }}
        >
          <TabContent className="live-demo-tab-item-content">
            <div>
              <div className="live-demo-tab-item-panel">
                <Resolution i18n={i18n} liveDemoId={liveDemoId} />
                {
                  componentProps.languages
                  && <Language i18n={i18n} componentProps={componentProps} liveDemoId={liveDemoId} lang={lang} country={platform?.countryId} />
                }
              </div>
              <div className="live-demo-tab-item-demo">
                <SnippetSpinner />
                <View componentDemo={componentDemo} i18n={i18n} lang={lang} isMobile={isMobile.any} isLoggedAccountATestUser={isLoggedAccountATestUser}>
                  {(!isMobile.any && customMessage?.shouldShow) && (
                    <div className="live-demo-container__custom-message">
                      <Message hierarchy="quiet" color="accent" closable>
                        {customMessage?.content}
                      </Message>
                    </div>
                  )}
                </View>
              </div>
            </div>
          </TabContent>
        </Tab>
      ),
    },
    {
      visible: componentSnippetFront,
      content: (
        <Tab
          title="Frontend"
          className="live-demo-tab-item"
          onClick={() => {
            Tracker.send(`mpdevelopers/live_demo/click_${liveDemoId}_tab`, 'frontend');
          }}
        >
          <TabContent className="live-demo-tab-item-snippet">
            <SnippetFront componentSnippetFront={componentSnippetFront} i18n={i18n} liveDemoId={liveDemoId} />
          </TabContent>
        </Tab>
      ),
    },
    {
      visible: componentSnippetBack,
      content: (
        <Tab
          title="Backend"
          className="live-demo-tab-item"
          onClick={() => {
            Tracker.send(`mpdevelopers/live_demo/click_${liveDemoId}_tab`, 'backend');
          }}
        >
          <TabContent className="live-demo-tab-item-snippet">
            <SnippetBack componentSnippetBack={componentSnippetBack} i18n={i18n} liveDemoId={liveDemoId} />
          </TabContent>
        </Tab>
      ),
    },
  ];

  const tabsItens = (
    <Tabs behavior="fullWidth" className="live-demo-tab-list">
      {tabContent.filter((item) => item?.visible).map((item) => item?.content)}
    </Tabs>
  );

  return (
    <LiveDemoContextProvider initialValues={initialValues}>
      <CustomHook customHook={customHook} />
      <div className="live-demo-container">
        <div className="live-demo-prop-container">
          <div className="live-demo-bradcrumb">
            <Breadcrumb levels={componentProps?.breadCrumbLevels} srLabel={i18n.gettext('Demostración')}>
              {componentProps?.breadCrumbLevels.map(element => <BreadcrumbLevel {...element} />)}
            </Breadcrumb>
          </div>

          <Properties
            componentProps={componentProps}
            isMobile={deviceType === 'mobile'}
            i18n={i18n}
            liveDemoId={liveDemoId}
            lang={lang}
          />

          <FeedbackCSAT
            i18n={i18n}
            site_id={platform.siteId}
            user_id={userData.id}
            email={email}
            lang={lang}
            loginCallbackUrl={`${actualUrl.host}${actualUrl.fullPath}`}
          />
        </div>
        {deviceType === 'mobile' && <div className="live-demo-results">{i18n.gettext('Resultados')}</div>}
        <div className="live-demo-tab-container">
          {deviceType === 'mobile'
            ? (
              <>
                <SnippetSpinner />
                <View componentDemo={componentDemo} i18n={i18n} lang={lang} isLoggedAccountATestUser={isLoggedAccountATestUser} />
                {customMessage?.shouldShow && (
                  <div className="live-demo-container__custom-message-mobile">
                    <Message hierarchy="quiet" color="accent" closable>
                      {customMessage?.content}
                    </Message>
                  </div>
                )}
              </>
            )
            : (
              tabsItens
            )}
        </div>

        <LiveDemoSnackbar i18n={i18n} />

      </div>
    </LiveDemoContextProvider>
  );
};

module.exports = Demo;
